/**
 * Created by Ning Jiang on 5/13/2019.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {
    IdleAnimationConfig,
    IdleAnimationController
} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {PixiesVsPiratesGameConfig} from "../PixiesVsPiratesGameConfig";
import {PixiesVsPiratesParsedGameData} from "../server/parseddata/PixiesVsPiratesParsedGameData";
import {PixiesVsPiratesParsedInitData} from "../server/parseddata/PixiesVsPiratesParsedInitData";
import {PPGameMode} from "../gamemode/PPGameMode";

export class ScatterIdleAnimationController extends IdleAnimationController {

    private _betWinsData:IBetWinData[] | null;
    private _mode:string;
    private _nextMode:string;
    private _allScatters:[number, number][];
    private _isNextNormalMode:boolean;

    constructor(config:IdleAnimationConfig) {
        super(config);
        this.stopIdleAnimation();
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, WinPresentationEvent.UPDATE_WIN_PRESENTATION_BET_WINS, (event:GameEvent) => this.onUpdateBetWins(event.params[0]));
    }

    private onInitDataParsed(data:PixiesVsPiratesParsedInitData):void {
        this.getScatterSymbolsFromReelSet(data.reels, data.gameAreaSize);
    }

    private getScatterSymbolsFromReelSet(reels:string[][], gameAreaSize:number[]):void{
        reels.forEach((reel:string[], reelId:number) => {
            const startSymId:number = 7 - gameAreaSize[reelId];
            reel.forEach((symName:string, symId:number) => {
                if(symId < startSymId || symId > 6) {
                    return;
                }
                if(symName === ReelSymbolName.SCATTER) {
                    this._allScatters.push([reelId, symId - 1]);
                }
            })
        })
    }

    protected onGameDataParsed(data:PixiesVsPiratesParsedGameData):void {
        this._betWinsData = data.betWins;
        this._mode === data.mode;
        this._nextMode === data.nextMode;
        this._isNextNormalMode = data.mode === PPGameMode.FREESPIN && data.nextMode === PPGameMode.NORMAL;
        if(this._isNextNormalMode){
            this.getScatterSymbolsFromReelSet(data.rawReelsEnteringFreespin, data.gameAreaSize);
        }
        else {
            data.scatterPositions!.forEach((symId: number, reelId: number) => {
                if (data.doReelNudge[reelId]) {
                    return;
                }
                if (symId > -1) {
                    this._allScatters.push([reelId, symId]);
                }
            });
        }
    }

    protected hasWin():boolean {
        const hasWin:boolean = this._betWinsData != null && this._betWinsData.length > 0;
        const noScatter:boolean = this._allScatters.length === 0;
        return (hasWin && !this._isNextNormalMode) || noScatter;
    }

    private onUpdateBetWins(wins:IBetWinData[]):void {
        this._betWinsData = wins.concat();
    }

    protected playIdleAnimation():void {
        this._allScatters.forEach((pos:[number, number]) => {
            const scatter:StateReelSymbol | null = Reels.getSymbol(pos[0], pos[1]);
            // Commenting idle animation for time being. Need to visit symbolId logic
            if(scatter) {
                scatter.changeState({
                    state : PixiesVsPiratesGameConfig.instance.SYMBOL_STATES.idle,
                    replay : true,
                    fadeInDuration : 0.5
                });
            }
        });
    }

    protected stopIdleAnimation():void {
        this._betWinsData = null;
        this._allScatters = [];
    }
}